// Nama kegiatan selalu tampil HURUF KAPITAL di seluruh tampilan (keputusan
// pemilik 15 Okt 2026). Hanya tampilan: data di server tetap seperti diketik
// pengaju, sehingga dokumen resmi (syahadah, SKL, email) tidak berubah.
//
// Diterapkan terpusat di klien API (lib/api.ts) untuk kolom `nama_kegiatan`
// dan `kegiatan_nama` pada setiap respons, karena nama kegiatan tampil di
// puluhan halaman. Aman karena tidak ada formulir yang memuat nama kegiatan
// dari server untuk disunting lalu disimpan ulang.

export function kapital(nama: string): string {
  return nama.toLocaleUpperCase('id-ID')
}

const KOLOM_TUNGGAL = new Set(['nama_kegiatan'])
const KOLOM_DAFTAR = new Set(['kegiatan_nama'])

// Menelusuri respons JSON dan mengubah nilai kolom nama kegiatan menjadi
// kapital, di kedalaman mana pun. Objek diubah di tempat lalu dikembalikan.
export function kapitalkanNamaKegiatan<T>(data: T, kedalaman = 0): T {
  if (kedalaman > 12 || data === null || typeof data !== 'object') return data
  if (Array.isArray(data)) {
    for (const x of data) kapitalkanNamaKegiatan(x, kedalaman + 1)
    return data
  }
  const obj = data as Record<string, unknown>
  for (const [k, v] of Object.entries(obj)) {
    if (KOLOM_TUNGGAL.has(k) && typeof v === 'string') obj[k] = kapital(v)
    else if (KOLOM_DAFTAR.has(k) && Array.isArray(v)) obj[k] = v.map((x) => (typeof x === 'string' ? kapital(x) : x))
    else if (v && typeof v === 'object') kapitalkanNamaKegiatan(v, kedalaman + 1)
  }
  return data
}
